import ConnectionKeys from 'automation-ui-action-features/constants/ConnectionKeys';
export const ConnectionMixinDefaultValues = {
  [ConnectionKeys.CONNECTION_TYPE]: null
};
/**
 * `ConnectionMixin` defines common behavior among the connection objects
 * found on every action, with the exception of non-branching leaf actions.
 * There are different configurations depending on the type of action. Each
 * method defined here should be overriden by each connection type's concrete
 * Record class to match its unique qualities.
 *
 * A non-branching action's connection object also functions as a Connector,
 * which describes how a following action is reached. Branching actions by
 * contrast feature multiple Connectors.  Leaf edges are represented by `null`
 * instead of a Connector object.
 */
function ConnectionMixin(superClass) {
  class ConnectionMixinClass extends superClass {
    isBranchConnection() {
      return false;
    }

    /**
     * This method should return an array of Connectors and leaves in an order
     * consistent with the connection type's edges.
     */

    /**
     * `updater` is a function which takes in a Connector and returns a new
     * Connector to replace it. This method should return a new Connection where
     * each connector or leaf is replaced with the result of calling `updater`
     * on that connector or leaf. The order should be consistent with
     * `getConnections()`.
     */

    /**
     * This method should return the Connector or leaf corresponding to the
     * given edge identifier.
     */

    /**
     * This method should return a new Connection where the Connector or leaf
     * corresponding to the given edge identifier is replaced with the given
     * `connector`.
     */
  }
  return ConnectionMixinClass;
}
export default ConnectionMixin;